import React from 'react';

const ModeToggle = ({ value, onChange, optionLeft = "Option 1", optionRight = "Option 2" }) => {
    return (
        <div className="relative flex w-full h-10 bg-gris dark:bg-gray-500 rounded-full p-1 text-base font-semibold">
            {/* Fond glissant */}
            <div
                className={`absolute top-1 left-1 w-[calc(50%-0.25rem)] h-[calc(100%-0.5rem)] bg-blanc dark:bg-gris/20 rounded-full shadow-md transform transition-transform duration-300 ease-in-out
                    ${value ? 'translate-x-full' : 'translate-x-0'}
                `}
            />

            {/* Boutons */}
            <button
                onClick={() => onChange(true)}
                className="flex-1 z-10 text-center transition-colors duration-300"
            >
                <span className={`${!value ? 'text-noir dark:text-blanc' : 'text-blanc dark:text-gris/60'}`}>
                    {optionLeft}
                </span>
            </button>
            <button
                onClick={() => onChange(false)}
                className="flex-1 z-10 text-center transition-colors duration-300"
            >
                <span className={`${value ? 'text-noir dark:text-blanc' : 'text-blanc dark:text-gris/60'}`}>
                    {optionRight}
                </span>
            </button>
        </div>
    );
};

export default ModeToggle;